import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '@shared/services/registration.service';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

    navigationBarActive: boolean;

    constructor(
        private readonly registrationService: RegistrationService
    ) {}

    ngOnInit(): void {
        this.registrationService.getNavBarActivationObservable()
            .subscribe(isActive => {
                this.navigationBarActive = isActive;
            });
    }
}
